import React from 'react';
import SeoHead from '../components/SeoHead';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Industries from '../components/Industries';
import Process from '../components/Process';
import About from '../components/About';
import Testimonials from '../components/Testimonials';
import BlogPreview from '../components/BlogPreview';

const HomePage = () => {
  return (
    <>
      <SeoHead path="/" />
      <Hero />
      <Services limit={6} />
      <Industries />
      <Process />
      <About />
      <Testimonials />
      <BlogPreview />
    </>
  );
};

export default HomePage;
